import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircle = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "M10 .399C4.697.399.399 4.697.399 9.999A9.6 9.6 0 0 0 10 19.6c5.301 0 9.6-4.298 9.6-9.601s-4.299-9.6-9.6-9.6m.896 3.466c.936 0 1.211.543 1.211 1.164 0 .775-.62 1.492-1.679 1.492-.886 0-1.308-.445-1.282-1.182 0-.621.519-1.474 1.75-1.474M8.498 15.749c-.64 0-1.107-.389-.66-2.094l.733-3.025c.127-.484.148-.678 0-.678-.191 0-1.022.334-1.512.664l-.319-.523c1.555-1.299 3.343-2.061 4.108-2.061.64 0 .746.756.427 1.92l-.84 3.18c-.149.562-.085.756.064.756.192 0 .82-.232 1.438-.719l.362.486c-1.513 1.512-3.162 2.094-3.801 2.094"
  })
});
const Memo = /*#__PURE__*/memo(SvgInfoCircle);
export default Memo;